<template>
    <div id="requestMobile">
        <div class="title" v-if="request">{{ request.title }}</div>
        <div class="subtitle" v-if="request">#{{ leftPad(request.id, 7) }}</div>
        <div class="section" v-if="request">
            <div class="leftIcon">
                <img src="@/assets/img/icons/calendar_2.png">
            </div>
            <div class="content">
                <div class="subtitle">{{ $t("requests.date") }}</div>
                {{ request.createdAt.format("DD/MM/YYYY - HH:mm") }}
            </div>
        </div>
        <div class="section" v-if="request && request.property">
            <div class="leftIcon">
                <img src="@/assets/img/icons/contact.png">
            </div>
            <div class="content">
                <div class="subtitle">{{ $t("address.building") }}</div>
                {{ request.property }}
            </div>
        </div>
        <div class="section" v-if="request && request.unit">
            <div class="leftIcon">
                <img src="@/assets/img/icons/contact.png">
            </div>
            <div class="content">
                <div class="subtitle">{{ $t("address.unit") }}</div>
                {{ request.unit }}
            </div>
        </div>
        <div class="section" v-if="request && request.phoneNumber">
            <div class="leftIcon">
                <img src="@/assets/img/icons/phone-grey.png">
            </div>
            <div class="content">
                <div class="subtitle">{{ $t("user.phone") }}</div>
                {{ request.phoneNumber }}
            </div>
        </div>
        <div class="section" v-if="request && request.categories[0]">
            <div class="leftIcon">
                <img src="@/assets/img/icons/category.png">
            </div>
            <div class="content">
                <div class="subtitle">{{ $t("requests.category.lv1") }}</div>
                {{ $to(request.categories[0]) }}
            </div>
        </div>
        <div class="section" v-if="request && request.categories[1]">
            <div class="leftIcon">
                <img src="@/assets/img/icons/category.png">
            </div>
            <div class="content">
                <div class="subtitle">{{ $t("requests.category.lv2") }}</div>
                {{ $to(request.categories[1]) }}
            </div>
        </div>
        <div class="section" v-if="request && request.categories[2]">
            <div class="leftIcon">
                <img src="@/assets/img/icons/category.png">
            </div>
            <div class="content">
                <div class="subtitle">{{ $t("requests.category.lv3") }}</div>
                {{ $to(request.categories[2]) }}
            </div>
        </div>
        <div class="section" v-if="request && request.body">
            <div class="leftIcon">
                <img src="@/assets/img/icons/comment.png">
            </div>
            <div class="content">
                <div class="subtitle">{{ $t("form.comments_precision") }}</div>
                {{ request.body }}
            </div>
        </div>
        <div class="section" v-if="request && request.decisionNote">
            <div class="leftIcon">
                <img src="@/assets/img/icons/contact.png">
            </div>
            <div class="content">
                <div class="subtitle">{{ $t("form.comments_admin") }}</div>
                {{ request.decisionNote }}
            </div>
        </div>
        <div class="section section-image" v-if="request && request.image">
            <div class="leftIcon">
                <img src="@/assets/img/icons/photo.png">
            </div>
            <div class="content">
                <div class="subtitle">{{ $t("form.photo") }}</div>
                <img :src="CONFIG.urlFiles + request.image" alt="">
            </div>
        </div>
        <div class="section" v-if="request && (request.emergency || request.canAccessIfAbsent || request.animal || request.alarm)">
            <div class="leftIcon">
            </div>
            <div class="content">
                <div class="subtitle">{{ $t("requests.details") }}</div>
                <div class="detailsLine" v-if="request.emergency">
                    <div class="icon"><img src="@/assets/img/icons/check.png"></div>
                    {{ $t("requests.urgent") }}
                </div>
                <div class="detailsLine" v-if="request.canAccessIfAbsent">
                    <div class="icon"><img src="@/assets/img/icons/check.png"></div>
                    {{ $t("requests.absent") }}
                </div>
                <div class="detailsLine" v-if="request.alarm">
                    <div class="icon"><img src="@/assets/img/icons/check.png"></div>
                    {{ $t("requests.alarm") }}<br>
                    {{ $t("requests.alarmCode") }}: {{ request.alarmCode }}
                </div>
                <div class="detailsLine" v-if="request.animal">
                    <div class="icon"><img src="@/assets/img/icons/check.png"></div>
                    {{ $t("requests.animal") }}
                </div>
            </div>
        </div>
        <div class="section" v-if="request && (request.status === 'completed' || request.status === 'in_progress')">
            <div class="leftIcon">
                <img src="@/assets/img/icons/comment.png">
            </div>
            <div class="content">
                <div class="subtitle">{{ $t("requests.messages") }}</div>
                <div class="discussion">
                    <div></div>
                    <div class="message" v-for="line of request.discussion">
                        <div class="from" :class="{'current-user' : isCurrentUser(line.user)}">{{line.from}}</div>
                        <div class="content">{{line.msg}}</div>
                    </div>
                </div>
                <div class="subtitle">{{ $t("requests.reply") }}</div>
                <textarea class="reply-text" :value="userReply" id="" name="" rows="10"
                          @input="$emit('update:userReply', $event.target.value)"></textarea>
                <div class="actions">
                    <button class="btn btn-primary reply-button" @click="reply"> {{$t('requests.send_reply')}} </button>
                </div>
            </div>
        </div>

        <div class="section" v-if="request && !(request.status === 'completed' || request.status === 'in_progress')">
            <div class="leftIcon">
                <img src="@/assets/img/icons/comment.png">
            </div>
            <div class="content">
                <div class="description">{{ $t("requests.not_available") }}</div>
            </div>
        </div>

        <div class="section"></div>

        <div class="buttons">
            <div class="btn btn-secondary" @click="back">{{ $t("navigation.back") }}</div>
            <div class="btn btn-primary" v-if="request && !request.isDone()" @click="cancel">{{ $t("requests.cancel") }}</div>
        </div>

    </div>
</template>

<script>

    import Requests from "../../../core/Requests";
    import {DateTime} from "luxon";

    export default {

        name: "RequestMobile",

        props: {
            leftPad: Function,
            back: Function,
            cancel: Function,
            reply: Function,
            isCurrentUser: Function,
            request:Object,
            userReply: String
        },

        data() {
            return {
                Requests,
                CONFIG
            };
        }

    }

</script>

<style lang="scss" scoped>
    #requestMobile {
        background-color: #f2f3f4;
        padding: 20px;
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        position: relative;
    }

    .title {
        font-size: 20px;
        font-weight: 500;
    }
    .subtitle {
        font-size: 12px;
        color: #808b91;
        margin-bottom: 25px;
    }

    .section {
        display: flex;
        flex-shrink: 0;
        padding: 20px 0;
        border-top: 1px solid #d9dcde;
        .leftIcon {
            width: 20px;
            margin-right: 20px;
            padding-top: 6px;
            text-align: center;
            flex-shrink: 0;
            .svgicon {
                fill: #808b91;
            }
        }
        .content {
            flex-grow: 1;
        }
        .subtitle {
            color: #bfc5c8;
            text-transform: uppercase;
            font-size: 12px;
            margin: 0;
        }
        .line {
            display: flex;
            .grow {
                flex-grow: 1;
            }
        }
        .detailsLine {
            position: relative;
            margin-top: 10px;
            margin-bottom: 20px;
            .icon {
                position: absolute;
                left: -40px;
                .svgicon {
                    fill: #808b91;
                }
            }
        }
    }

    .discussion {
        margin-top: 4px;
        margin-bottom: 20px;
        .message {
            display: flex;
            flex-direction: column;
            padding-left: 5px;
            background-color: #f2f3f4;

            &:nth-child(even) {
                background-color: #e2e3e4;
            }
        }
        .from {
            padding: 12px 12px 8px 12px;
            color: #676767;
            font-size: 14px;
            height: 100%;
            font-weight: bold;

            &.current-user {
                color: #94c11f;
            }
        }
        .content {
            padding: 0 12px 12px;
        }
    }

    .actions {
        display: flex;
    }

    .reply-button {
        //min-width: 125px;
        flex-grow: 1;
        flex-basis: 0;
    }

    .buttons {
        display: flex;
        margin-bottom: 20px;
        .btn {
            flex-grow: 1;
            flex-basis: 0;
        }
        .btn:not(:last-of-type) {
            margin-right: 20px;
        }
    }

    .section-image {
        .content img {
            max-width: 100%;
            max-height: 200px;
            margin-top: 7px;
            border-radius: 10px;
        }
    }

    #app {
        .reply-text {
            margin-top: 4px;
            margin-bottom: 10px;
            padding-top: 10px;
            box-sizing: border-box;
            width: 100%
        }
    }

</style>
